import { AdditionalOption } from '@/entities/room'
import { TContractRoomDetail, TRoomDetail } from '@/entities/room/model/schema'

// oldAdditionalOptions 또는 additionalOptions 중 하나가 있고 하나는 null
// oldAdditionalOptions는 additionalOptions + 이전 버전에만 있는 옵션
// petAllowed의 경우 additionalOptions 뒤에 추가되지만 oldAdditionalOptions에만 있는 옵션보다는 앞에 있어야 함
export const convertToContractRoomDetailProps = (room: TContractRoomDetail) => {
  const oldAdditionalOptions =
    room.isOldRoomOptions && room.oldAdditionalOptions
      ? room.oldAdditionalOptions
      : null

  const additionalOptions = oldAdditionalOptions
    ? oldAdditionalOptions.filter(option => option in AdditionalOption)
    : (room.additionalOptions ?? [])

  const oldOnlyAdditionalOptions = oldAdditionalOptions
    ? oldAdditionalOptions.filter(option => !(option in AdditionalOption))
    : []

  const finalAdditionalOptions = [
    ...(room.petAllowed ? [AdditionalOption.PET_ALLOWED] : []),
    ...(additionalOptions ?? []),
    ...oldOnlyAdditionalOptions,
  ]

  const includeInternet = room.isOldRoomOptions
    ? (room.includeInternet ?? false)
    : null

  return {
    ...room,
    roomUrl: null,
    like: false,
    additionalOptions: finalAdditionalOptions,
    includeInternet,
  }
}

export const convertToRoomDetailProps = (room: TRoomDetail) => {
  const additionalOptions = [
    ...(room.petAllowed ? [AdditionalOption.PET_ALLOWED] : []),
    ...room.additionalOptions,
  ]

  return {
    ...room,
    additionalOptions,
  }
}
